import PropTypes from 'prop-types'
import { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import classes from './index.module.scss'
import { selectById } from './store/slice'

const Name = ({ value, rowId, updateTemplate, page, pageSize }) => {
  const byId = useSelector(selectById)

  const inputRef = useRef()

  const [isShowButtonEdit, setIsShowButtonEdit] = useState(false)
  const [isShowEdit, setIsShowEdit] = useState(false)
  const [valueInput, setValueInput] = useState(value)

  const template = byId[rowId]

  const hoverName = () => setIsShowButtonEdit(true)

  const unhoverName = () => setIsShowButtonEdit(false)

  const showEdit = () => {
    setIsShowEdit(true)
    setValueInput(value)
    setTimeout(() => {
      inputRef.current?.focus()
    }, 200)
  }

  const hideEdit = () => {
    setIsShowEdit(false)
    setIsShowButtonEdit(false)
  }

  const changeInput = (e) => setValueInput(e.target.value)

  const update = () => {
    const newName = valueInput.trim()
    if (newName && newName !== value) {
      const newTemplate = { ...template }
      delete newTemplate.createDate
      delete newTemplate.updateDate
      delete newTemplate.count
      newTemplate.templateName = newName
      newTemplate.nameUpdateOnly = true
      updateTemplate({
        param: newTemplate,
        paramGet: {
          Page: page,
          PageSize: pageSize,
        },
      })
    }
    hideEdit()
  }

  return (
    <span onMouseEnter={hoverName} onMouseLeave={unhoverName}>
      {!isShowEdit ? (
        <>
          {value}
          <Icon
            style={{
              color: '#9C9C9C',
              fontSize: 12,
              opacity: isShowButtonEdit ? 1 : 0,
            }}
            className={`icon-edit-outline ${classes.iconEdit}`}
            onClick={showEdit}
          />
        </>
      ) : (
        <div className="dFlex">
          <Element
            elementName="input"
            className={classes.input}
            value={valueInput}
            ref={inputRef}
            onChange={changeInput}
          />
          <div>
            <Icon
              style={{ fontSize: 9, color: '#9C9C9C' }}
              className="ml1 icon-delete"
              onClick={hideEdit}
            />
            <Icon
              style={{ fontSize: 11, color: '#3DA967' }}
              className="ml1 icon-tick"
              onClick={update}
            />
          </div>
        </div>
      )}
    </span>
  )
}

Name.propTypes = {
  value: PropTypes.string,
  rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  updateTemplate: PropTypes.func,
}

export default Name
